// PannerNode pool — pre-allocated HRTF panners we hand out round-robin to
// one-shot SFX. Spinning up a PannerNode per play() call is wasteful and
// causes GC churn during heavy combat; the pool keeps allocation flat.
//
// Panners are positioned in world space (matching the camera's reference
// frame) so distant sounds attenuate naturally and left/right placement
// reads in stereo. Distance model is `inverse` with a 5-unit refDistance
// (full volume inside that radius) and 50-unit maxDistance (silent beyond).

const POOL_SIZE = 32;

let pool: PannerNode[] = [];
let nextIdx = 0;
let initialized = false;

export function initSpatialPool(ctx: AudioContext, destination: AudioNode): void {
  if (initialized) {
    for (const p of pool) {
      try {
        p.disconnect();
      } catch {
        /* already disconnected */
      }
    }
    pool = [];
  }
  for (let i = 0; i < POOL_SIZE; i++) {
    const p = new PannerNode(ctx, {
      panningModel: 'HRTF',
      distanceModel: 'inverse',
      refDistance: 5,
      maxDistance: 50,
      rolloffFactor: 1,
    });
    p.connect(destination);
    pool.push(p);
  }
  nextIdx = 0;
  initialized = true;
}

export function getPanNode(): PannerNode {
  if (pool.length === 0) throw new Error('spatial pool not initialized');
  const node = pool[nextIdx % pool.length] as PannerNode;
  nextIdx = (nextIdx + 1) % pool.length;
  return node;
}

export function isSpatialReady(): boolean {
  return initialized && pool.length > 0;
}
